<script setup lang="ts">
import Dialog from "@/cms/components/Dialog/Dialog.vue";
import { LayoutSelectorProps } from "@/cms/dialogs/LayoutSelector/LayoutSelector.types.ts";
import { watch, nextTick } from "vue";
import LayoutSelectorForm from "@/cms/dialogs/LayoutSelector/LayoutSelectorForm.vue";

const props = withDefaults(defineProps<LayoutSelectorProps>(), {
  title: "Select Layout",
  isSingleColumn: false,
  identifierProp: "name",
});

const selectedPropValue = defineModel<string>("selectedPropValue", {
  required: true,
});

const open = defineModel<boolean>("open", { default: false });

watch(
  () => open.value,
  () => {
    if (!open.value) {
      return;
    }

    nextTick(() => {
      const selectedLayout = document.querySelector(
        `[data-layout-name="${selectedPropValue.value}"]`
      );

      if (selectedLayout) {
        selectedLayout.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    });
  }
);
</script>

<template>
  <Dialog
    v-model="open"
    :title
    size="large"
    description="Choose from the available layouts below. Changes are applied automatically."
  >
    <template #default>
      <LayoutSelectorForm
        v-bind="props"
        v-model:selected-prop-value="selectedPropValue"
      />
    </template>
  </Dialog>
</template>
